import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/pecom.kz/www/frontend/layouts/default.vue").then(m => m.default || m))
}